import React, { ChangeEvent } from 'react';
import { mediaQueries } from '../../styles/media-queries';
import { formatToPhone } from '../../utils/formatPhoneNumber';

import styled from '../../theme/styled-with-theme';

const BaseInput = React.forwardRef(
  ({ type = 'text', value, onChange, ...props }: any, ref) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      let formatted;

      switch (type) {
        case 'tel':
          formatted = formatToPhone(e.target.value);
          break;
        case 'email':
        case 'text':
        default:
          formatted = e.target.value;
          break;
      }

      onChange(formatted || '');
    };

    return (
      <input
        ref={ref}
        {...props}
        type={type}
        value={value}
        onChange={handleChange}
        maxLength={type === 'text' ? 320 : 14}
      />
    );
  }
);

const Input = styled(BaseInput)`
  padding: ${({ theme }) => `${theme.spacing.s} ${theme.spacing.sm}`};
  font-size: ${({ theme }) => theme.fontSize.input_tablet};
  appearance: none;
  -webkit-appearance: none;
  outline: 0;
  border: ${({ theme }) => `1px solid ${theme.color.inputBorder}`};
  border-radius: ${({ theme }) => theme.borderRadius.input};
  color: ${({ theme }) => theme.color.black};
  &::placeholder {
    color: ${({ theme }) => theme.color.black};
  }

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  }
`;

export default Input;
